import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']

  select(event) {
    const button = event.currentTarget
    const feature = button.dataset.feature
    if (!feature) return

    this.buttonTargets.forEach((btn) => btn.classList.remove('selected'))
    button.classList.add('selected')

    const targetElement = document.getElementById(feature)
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}
